/* index.tsx */
import React from "react";

import { Icon } from "Components/atoms/Icon";
import { Typography } from "Components/atoms/Typography";
import {
  SallerActionContent,
  SallerContent,
  SellerAction,
  SellerItem,
  SellerLogo,
  SellerName,
  SellerPrice,
  SellersListContainer,
} from "./styles";
import { formatCurrency } from "shared/utils/prices";
import { SellersListProps } from "./types";
import { getDeeplink } from "shared/utils/DeepLink/getDeepLink";

const SELLER_LOGO_FALLBACKS: Record<string, string> = {
  "123milhas": "https://cloud.voopter.com.br/site-home/airlines/123milhas.png",
  viaza: "https://www.viaza.com.br/images/viaza-logo.svg",
};

export const getSellerLogoFallback = (
  seller: SellersListProps["sellers"][number],
) => SELLER_LOGO_FALLBACKS[seller.integrationName.toLowerCase()];

export const getSellerLogo = (seller: SellersListProps["sellers"][number]) =>
  seller.sellerImg || getSellerLogoFallback(seller) || seller.sellerImg;

export const applySellerLogoFallback = (
  seller: SellersListProps["sellers"][number],
  image: HTMLImageElement,
) => {
  const fallback = getSellerLogoFallback(seller);

  if (fallback && image.src !== fallback) {
    image.src = fallback;
  }
};

/**
 * Componente SellersList
 *
 * Exibe uma lista de vendedores com preços e botões para redirecionamento.
 *
 * @param {Array} pricingOptions - Lista de preços dos vendedores.
 */
export const SellersList: React.FC<SellersListProps> = ({
  sellers,
  cardResult,
  sellersRef,
}) => (
  <SellersListContainer ref={sellersRef}>
    {sellers.map((seller, index) => (
      <SellerItem key={`${seller.sellerName}-${index}`}>
        <SallerContent>
          <SellerLogo
            src={getSellerLogo(seller)}
            alt={seller.sellerName}
            onError={(event) =>
              applySellerLogoFallback(seller, event.currentTarget)
            }
          />
          <SellerPrice>
            <Typography
              as="span"
              variant="caption"
              color="black"
              weight="light"
            >
              R$
            </Typography>
            &nbsp;
            <Typography as="span" variant="h3" color="black" weight="bold">
              {formatCurrency(seller.price).first}
            </Typography>
            <Typography as="span" variant="label" color="black" weight="bold">
              ,{formatCurrency(seller.price).second}
            </Typography>
          </SellerPrice>
        </SallerContent>
        <SellerAction
          onClick={() => window.open(getDeeplink(cardResult, seller), "_blank")}
        >
          <SallerActionContent>
            <Typography color="white" variant="caption" uppercase>
              Ver no site
            </Typography>
            <SellerName>
              <Typography
                color="white"
                weight="semiBold"
                variant="caption"
                uppercase
              >
                {seller.sellerName}
              </Typography>
            </SellerName>
          </SallerActionContent>

          <Icon
            library="md"
            name="MdArrowForwardIos"
            size="medium"
            color="white"
          />
        </SellerAction>
      </SellerItem>
    ))}
  </SellersListContainer>
);
